var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4983",
    "data-name": "Group 4983",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5978",
    "data-name": "Path 5978",
    d: "M1142.5,1147h-3a3.509,3.509,0,0,1-3.375-2.569.539.539,0,0,0-.495-.431h-6.13a.5.5,0,0,1,0-1h6.13a1.528,1.528,0,0,1,1.46,1.165,2.5,2.5,0,0,0,2.41,1.835h3a2.5,2.5,0,0,0,2.41-1.835,1.528,1.528,0,0,1,1.46-1.165h6.13a.5.5,0,0,1,0,1h-6.13a.539.539,0,0,0-.495.431A3.509,3.509,0,0,1,1142.5,1147Z",
    transform: "translate(-1129 -1128)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5979",
    "data-name": "Path 5979",
    d: "M1148.5,1141a.5.5,0,0,1-.5-.5v-8.731l-2.74-2.769H1134v11.5a.5.5,0,0,1-1,0v-12a.5.5,0,0,1,.5-.5h11.969a.5.5,0,0,1,.355.148l3.031,3.063a.5.5,0,0,1,.145.352v8.937A.5.5,0,0,1,1148.5,1141Z",
    transform: "translate(-1129 -1128)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5980",
    "data-name": "Path 5980",
    d: "M1144,1134.5h-6a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z",
    transform: "translate(-1129 -1128)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5981",
    "data-name": "Path 5981",
    d: "M1144,1138.5h-6a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z",
    transform: "translate(-1129 -1128)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5982",
    "data-name": "Path 5982",
    d: "M1150.5,1152h-19a2.5,2.5,0,0,1-2.5-2.5v-6l1-9.056a.5.5,0,0,1,.994.112l-1,9,0,5.944a1.5,1.5,0,0,0,1.5,1.5h19a1.5,1.5,0,0,0,1.5-1.5v-6l-1-8.944a.5.5,0,0,1,.994-.112l1,9,0,6.056A2.5,2.5,0,0,1,1150.5,1152Z",
    transform: "translate(-1129 -1128)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.cecc9a1292edf3321d50758b8289a961.svg";
export { ForwardRef as ReactComponent };